export const API_URL = process.env.NEXT_PUBLIC_API_URL;

export const googleAds = {
    signupConversionLabel: 'AW-11523926491/boWxCJfX-KgbENvThPcq',
};

export const videoCreditCosts = { 5: 4, 10: 8 };
export const videoPricingDescription = `Videos cost ${videoCreditCosts[5]} credits for 5 seconds or ${videoCreditCosts[10]} credits for 10 seconds.`;

export const pricing = {
    tiers: [
        // {
        //     name: 'Trial',
        //     id: 'tier-trial',
        //     price_id_usd: "price_1SWRQFDfuhIaryJbpAO5wipL",
        //     price_id_mxn: "price_1SWRQTDfuhIaryJbp6CpFv3j",
        //     price_usd: 6,
        //     price_mxn: 100,
        //     description: 'Try Provamoda risk-free',
        //     features: [
        //         '20 credits = 20 images',
        //         '1K resolution',
        //     ],
        //     mostPopular: false,
        // },
        {
            name: 'Basic',
            id: 'tier-hobby',
            // price_id_usd: "price_1QljaWDfuhIaryJbv9dfso8S",
            price_id_usd: "price_1SVzRKDfuhIaryJbiIeKeGe4",
            price_id_mxn: "price_1SW0VCDfuhIaryJbEl7Uhg9I",
            price_usd: 35,
            price_mxn: 612.50,
            description: 'The essentials to get started',
            features: [
                '140 credits = 140 images',
                'High resolution',
                'Image editing with prompts',
            ],
            mostPopular: false,
        },
        {
            name: 'Professional',
            id: 'tier-freelancer',
            price_usd: 99,
            price_mxn: 1732.50,
            price_id_usd: "price_1SVzSYDfuhIaryJbmKqY4SWL",
            price_id_mxn: "price_1SW0UyDfuhIaryJb6JvlLzvt",
            saving_percentage: 18.5,
            description: 'For growing businesses',
            features: [
                '450 credits = 450 images',
                'High resolution',
                'Video generation',
                'Image editing with prompts',
            ],
            mostPopular: true,
        },
        {
            name: 'Enterprise',
            id: 'tier-startup',
            price_usd: 450,
            price_mxn: 7875,
            price_id_usd: "price_1SVzSyDfuhIaryJb1kqPl2Va",
            price_id_mxn: "price_1SW0VSDfuhIaryJbzkoNk1ds",
            saving_percentage: 27.5,
            description: 'For large businesses',
            features: [
                '2300 credits = 2300 images',
                'Ultra High resolution',
                'Video generation',
                'Image editing with prompts',
            ],
            mostPopular: false,
        }
    ],
}